/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';

import apiNew from '../../api/api';
import { errorHandling } from '../../api/errorHandling';
import {
 addCommentFailure,
 AddCommentPayload,
 addCommentStart,
 addCommentSuccess,
 deleteCommentFailure,
 deleteCommentStart,
 deleteCommentSuccess,
 getCommentsFailure,
 GetCommentsPayload,
 getCommentsStart,
 getCommentsSuccess,
 updateCommentFailure,
 updateCommentStart,
 updateCommentSuccess,
} from './commentsSlice';

function* getCommentsSaga(action: PayloadAction<GetCommentsPayload>) {
 try {
  const response: AxiosResponse<any> = yield call(apiNew.post, '/Comments/v1', {
   filters: [
    {
     field: 'Table',
     operator: 'eq',
     value: action.payload.table,
     logic: 'and',
    },
    {
     field: 'TableRecordId',
     operator: 'eq',
     value: action.payload.id,
    },
   ],
  });

  yield put(
   getCommentsSuccess({
    comments: response.data,
   }),
  );
 } catch (error) {
  yield* errorHandling(error, getCommentsFailure);
 }
}

function* addCommentSaga(action: PayloadAction<AddCommentPayload>) {
 try {
  const response: AxiosResponse<any> = yield call(
   apiNew.post,
   '/Comments/v1/create',
   action.payload,
  );

  yield put(
   addCommentSuccess({
    message: 'Comment added successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, addCommentFailure);
 }
}

function* updateCommentSaga(
 action: PayloadAction<{ id: number; Text: string }>,
) {
 try {
  const response: AxiosResponse<any> = yield call(
   apiNew.put,
   `/Comments/v1/update/${action.payload.id}`,
   { Text: action.payload.Text },
  );

  yield put(
   updateCommentSuccess({
    message: 'Comment updated successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, updateCommentFailure);
 }
}
function* deleteCommentSaga(action: PayloadAction<{ id: number }>) {
 try {
  const response: AxiosResponse<any> = yield call(
   apiNew.del,
   `/Comments/v1/delete/${action.payload.id}`,
   {},
  );

  yield put(
   deleteCommentSuccess({
    message: 'Comment deleted successfully',
    type: 'success',
   }),
  );
 } catch (error) {
  yield* errorHandling(error, deleteCommentFailure);
 }
}

export function* watchCommentsSaga() {
 yield takeLatest(getCommentsStart.type, getCommentsSaga);
 yield takeLatest(addCommentStart.type, addCommentSaga);
 yield takeLatest(updateCommentStart.type, updateCommentSaga);
 yield takeLatest(deleteCommentStart.type, deleteCommentSaga);
}
